import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject, takeUntil, finalize } from 'rxjs';
import { FiltersService } from 'app/shared/components/main-map/components/search-results/filters.service';
import { ToastService } from 'app/shared/services/toast.service';
import { LoadingController } from 'app/shared/helpers/loading.controller';
import { MapFilterManager } from '../../map-filter.manager';
import { TranslationService } from '@services/translation.service';

interface SaveFilterForm {
  name: FormControl<string>;
}

@Component({
  selector: 'app-save-filter-form',
  templateUrl: 'save-filter-form.component.html',
  styleUrls: ['save-filter-form.component.scss'],
})
export class SaveFilterFormComponent implements OnInit, OnDestroy {
  @Input()
  visible: boolean;
  @Output()
  visibleChange = new EventEmitter<boolean>();

  formGroup: FormGroup<SaveFilterForm>;

  private lifecycle = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private filterService: FiltersService,
    private mapFilterManager: MapFilterManager,
    private toastService: ToastService,
    private globalLoadingController: LoadingController,
    private ts: TranslationService
  ) {}

  ngOnInit(): void {
    this.formGroup = this.formBuilder.group({
      name: this.formBuilder.control<string>(null),
    });
  }

  ngOnDestroy(): void {
    this.lifecycle.next();
    this.lifecycle.complete();
  }

  onHiddenInternal() {
    this.formGroup.reset();
  }

  onSubmit(e) {
    e?.preventDefault();

    if (this.globalLoadingController.isShown()) {
      return;
    }

    const { name } = this.formGroup.getRawValue();

    const state = this.mapFilterManager.getState();
    state.name = name;

    this.globalLoadingController.show();
    this.filterService
      .saveFilterState(state)
      .pipe(
        finalize(() => {
          this.globalLoadingController.hide();
        }),
        takeUntil(this.lifecycle)
      )
      .subscribe({
        next: () => {
          this.toastService.success(`Pesquisa guardada com sucesso`);

          this.visible = false;
          this.visibleChange.emit(this.visible);
        },
        error: (response) => {
          if (!response) {
            return;
          }

          this.toastService.error(
            this.ts.getCurrentLanguage()['failed-save-search']
          );
        },
      });
  }

  onBtnCancelClick() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
